import { render } from "./SearchAgendaItem.vue?vue&type=template&id=41ec5ee4"
import script from "./SearchAgendaItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SearchAgendaItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./SearchAgendaItem.vue?vue&type=style&index=0&id=41ec5ee4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__